<template>
  <div>ConsumablesManagement</div>
</template>

<script>
export default {

}
</script>

<style>

</style>